import { render, staticRenderFns } from "./settingpagealert.vue?vue&type=template&id=0557b09e&"
import script from "./settingpagealert.vue?vue&type=script&lang=js&"
export * from "./settingpagealert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0557b09e')) {
      api.createRecord('0557b09e', component.options)
    } else {
      api.reload('0557b09e', component.options)
    }
    module.hot.accept("./settingpagealert.vue?vue&type=template&id=0557b09e&", function () {
      api.rerender('0557b09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/errors/settingpagealert.vue"
export default component.exports